import React from 'react';
import { useState, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import {
  Card,
  Form,
  Input,
  Button,
  Row,
  Col,
  Steps,
  Upload,
  message,
  Select,
  Space,
  Modal,
} from 'antd';

import step_base_icon from '../../../../assets/icons/step_base_icon.png';
import dangerIcon from '../../../../assets/icons/danger_icon.png';
import inactive_bbs from '../../../../assets/icons/inactive_bbs.png';
import { fetchEditProjectUser, fetchEditProject } from '../../redux/slice.js';
import {
  getApproverDashboard,
  getApproveReject,
} from '../../../dashboard/redux/slice.js';
import { useSelector, useDispatch } from 'react-redux';
//import { TextArea } from 'semantic-ui-react';
import { useParams } from 'react-router-dom';
import { ConsoleSqlOutlined } from '@ant-design/icons';

const { Step } = Steps;
const { TextArea } = Input;

const UserApproveReject = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { Option } = Select;

  const [form] = Form.useForm();
  const [formData, setFormData] = useState({});

  const [currentStep, setCurrentStep] = useState(0);

  const [isStepperFormVisible, setIsStepperFormVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isBackdropBlurred, setIsBackdropBlurred] = useState(false);
  const [isRejectionModalVisible, setRejectionModalVisible] = useState(false);
  const [isUserRejectionModalVisible, setUserRejectionModalVisible] =
    useState(false);
  const [stepOneData, setStepOneData] = useState({});

  // Handle modal visibility
  const showRejectionModal = () => {
    setRejectionModalVisible(true);
  };
  const showUserRejectionModal = () => {
    setUserRejectionModalVisible(true);
  };

  const handleRejectionConfirm = () => {
    // form
    // .validateFields()
    // .then((values) => {
    //   const payload = {
    //       Id:fetchApproveReject?.id,
    //       status:'Rejected',
    //       remarks:values?.remarks
    //   };  // Payload to pass to the API
    //   console.log('Payload:', payload);

    //   dispatch(createManagerApproveProject(payload))  // Dispatch the API call
    //     .then((response) => {
    //       if (response?.payload?.success) {
    //         message.success(response?.message);
    //         navigate('/dashboard')
    //       } else {
    //         message.error(response?.payload?.error || 'Unknown error');
    //       }
    //     })
    //     .catch((error) => {
    //       console.error('API call failed:', error);
    //       message.error('Failed to submit the form.');
    //     });
    // })
    // .catch((info) => {
    //   console.log('Validation failed:', info);
    // });
    setRejectionModalVisible(false); // Close modal
  };

  const handleUserRejectionConfirm = () => {
    // form
    // .validateFields()
    // .then((values) => {
    //   const payload = {
    //     userId:fetchApproveReject?.id,
    //     requestApprovalId:fetchApproveReject?.request_approval_id,
    //     status:'Rejected',
    //     remarks:values?.remarks
    //   };  // Payload to pass to the API
    //   console.log('Payload:', payload);

    //   dispatch(createManagerApproveUser(payload))  // Dispatch the API call
    //     .then((response) => {
    //       if (response?.payload?.success) {
    //         message.success(response?.message);
    //         navigate('/dashboard')
    //       } else {
    //         message.error(response?.payload?.error || 'Unknown error');
    //       }
    //     })
    //     .catch((error) => {
    //       console.error('API call failed:', error);
    //       message.error('Failed to submit the form.');
    //     });
    // })
    // .catch((info) => {
    //   console.log('Validation failed:', info);
    // });
    setUserRejectionModalVisible(false); // Close modal
  };

  const handleRejectionCancel = () => {
    setRejectionModalVisible(false); // Close modal
  };

  const handleUserRejectionCancel = () => {
    setUserRejectionModalVisible(false); // Close modal
  };

  const clearForm = () => {
    form.resetFields();
    setFormData({});
  };

  const { fetchApproveReject, loading } = useSelector(
    (state) => state.projectList,
  );

  useEffect(() => {
    let payload = {
      id: params.id,
    };

    dispatch(getApproveReject(payload));
  }, [dispatch]);

  console.log('paramsid: ', params.id);

  console.log('Approve_Reject: ', fetchApproveReject);
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const handleProjectEdit = (id) => {
    if (!id) {
      console.error('Invalid ID');
      return;
    }

    form
      .validateFields()
      .then((values) => {
        const payload = {
          manager_project_remarks: values?.manager_project_remarks,
          quantity: values?.quantity,
          wastagePer: values?.wastagePer,
          role: values?.role,
        };

        console.log('Payload:', payload);

        // Dispatch the API call with the dynamic `id` in the URL
        dispatch(fetchEditProject({ payload, id })) // Passing both payload and id
          .then((response) => {
            if (response?.payload?.success) {
              message.success(
                response?.payload?.message || 'Action successful',
              );
              getApproverDashboard();
              //setCurrentStep(currentStep + 1);
              setIsSubmitClicked(true); // Redirect to the dashboard upon success
              navigate('/dashboard');
            } else {
              message.error(
                response?.payload?.error || 'Unknown error occurred',
              );
            }
          })
          .catch((error) => {
            console.error('API call failed:', error);
            message.error('Failed to submit the form.');
          });
      })
      .catch((info) => {
        console.log('Validation failed:', info);
      });
  };

  const nextStep = () => {
    form
      .validateFields()
      .then((values) => {
        console.log('Step 1 Data:', values);
        setStepOneData(values); // Save step 1 data in stat
        setCurrentStep(currentStep + 1); // Move to Step 2
      })
      .catch((info) => {
        console.log('Validation failed:', info);
        message.error('Please fill all required fields before proceeding.');
      });
  };
  useEffect(() => {
    console.log('Form data updated:', formData);
  }, [formData]);

  const clearform = () => {
    form.resetFields();
  };

  //   const handleProjectApprove=()=>{
  //      form
  //           .validateFields()
  //           .then((values) => {
  //             const payload = {
  //                 Id:fetchApproveReject?.id,
  //                 status:'Approved',
  //                 //remarks:values?.remarks
  //             };  // Payload to pass to the API
  //             console.log('Payload:', payload);

  //             dispatch(createManagerApproveProject(payload))  // Dispatch the API call
  //               .then((response) => {
  //                 if (response?.payload?.success) {
  //                   message.success(response?.message);
  //                   setCurrentStep(currentStep + 1);
  //                 } else {
  //                   message.error(response?.payload?.error || 'Unknown error');
  //                 }
  //               })
  //               .catch((error) => {
  //                 console.error('API call failed:', error);
  //                 message.error('Failed to submit the form.');
  //               });
  //           })
  //           .catch((info) => {
  //             console.log('Validation failed:', info);
  //           });
  //   }

  const handleUserEdit = (id) => {
    if (!id) {
      console.error('Invalid ID');
      return;
    }

    form
      .validateFields()
      .then((values) => {
        const payload = {
          manager_user_remarks: values?.manager_user_remarks,
        };

        console.log('Payload:', payload);

        // Dispatch the API call with the dynamic `id` in the URL
        dispatch(fetchEditProjectUser({ payload, id })) // Passing both payload and id
          .then((response) => {
            if (response?.payload?.success) {
              message.success(
                response?.payload?.message || 'Action successful',
              );
              getApproverDashboard();
              navigate('/dashboard'); // Redirect to the dashboard upon success
            } else {
              message.error(
                response?.payload?.error || 'Unknown error occurred',
              );
            }
          })
          .catch((error) => {
            console.error('API call failed:', error);
            message.error('Failed to submit the form.');
          });
      })
      .catch((info) => {
        console.log('Validation failed:', info);
      });
  };

  const [stepStyle, setStepStyle] = useState({ width: 'auto' });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width < 575) {
        setStepStyle({ width: 'auto' });
      } else if (width < 768) {
        setStepStyle({ width: '100%' });
      } else {
        setStepStyle({ width: 'auto' });
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (fetchApproveReject?.RequestApproval?.project_status === 'Approved') {
      form.setFieldsValue({
        manager_project_remarks:
          fetchApproveReject?.RequestApproval?.manager_project_remarks,
      });
    }
  }, [fetchApproveReject, form]);

  const steps = [
    {
      title: <div className="step-title">Project Request</div>,
      content: (
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            quantity: fetchApproveReject?.RequestApproval?.quantity,
            wastagePer: fetchApproveReject?.RequestApproval?.wastagePer,
            role: fetchApproveReject?.RequestApproval?.role,
            //   manager_project_remarks: fetchApproveReject?.RequestApproval?.manager_project_remarks
          }}
        >
          <Row gutter={24}>
            <Col span={12} xs={24} sm={12}>
              <Form.Item label="Project Code">
                <Input
                  value={fetchApproveReject?.RequestApproval?.project_code}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Project Name"

                //rules={[{ required: true, message: 'Please select a project' }]}
              >
                <Input
                  value={fetchApproveReject?.RequestApproval?.project_name}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="SBG"

                //rules={[{ message: "Please enter the project code" }]}
              >
                <Input
                  value={fetchApproveReject?.RequestApproval?.sbg}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="SBU"

                //rules={[{ message: "Please enter the project code" }]}
              >
                <Input
                  value={fetchApproveReject?.RequestApproval?.sbu}
                  disabled
                />
              </Form.Item>
            </Col>

            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="BU"
                rules={[{ message: 'Please enter the project name' }]}
              >
                <Input
                  value={fetchApproveReject?.RequestApproval?.bu}
                  disabled
                />
              </Form.Item>
            </Col>

            {console.log(
              'values@@: ',
              fetchApproveReject?.RequestApproval?.quantity,
            )}
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Total Reinforcement Quantity (in MT)"
                name="quantity"
              >
                <Input
                  placeholder="Enter total reinforcement quantity (in MT)"
                  disabled={
                    fetchApproveReject?.RequestApproval?.project_status ==
                    'Approved'
                  }
                />
              </Form.Item>
            </Col>
            {/* Enable 'Wastage Percentage Considered' input field when 'Rejected' */}
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Budgeted Wastage in PET/CB/CTC* (in %)"
                name="wastagePer"
              >
                <Input
                  placeholder="Enter budgeted wastage"
                  disabled={
                    fetchApproveReject?.RequestApproval?.project_status ==
                    'Approved'
                  }
                />
              </Form.Item>
            </Col>
            {/* Enable 'Role of the BBS User' Select field when 'Rejected' */}
            <Col span={12} xs={24} sm={12}>
              <Form.Item label="Role of Employee" name="role">
                <Select
                  placeholder="Select role of the employee"
                  disabled={
                    fetchApproveReject?.RequestApproval?.project_status ==
                    'Approved'
                  }
                >
                  <Option value="planning_engineer">Planning Engineer</Option>
                  <Option value="site_supervision">Site Supervision</Option>
                  <Option value="project_management">Project Management</Option>
                  <Option value="technical_expertise">
                    Technical Expertise
                  </Option>
                  <Option value="Design_and_planning">
                    Design and Planning
                  </Option>
                  <Option value="BBS Engineer">BBS Engineer</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={24}>
              {/* Enable 'Remarks' TextArea when 'Rejected' */}
              <Form.Item label="Remarks" name="manager_project_remarks">
                <TextArea
                  placeholder="Enter remarks"
                  rows={3}
                  style={{ width: '100%' }}
                  disabled={
                    fetchApproveReject?.RequestApproval?.project_status ==
                    'Approved'
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      ),
    },
    {
      title: <div className="step-title">User Request</div>,
      content: (
        <Form form={form} layout="vertical">
          <Row gutter={24}>
            <Col span={12} xs={24} sm={12}>
              <Form.Item label="Project Code">
                <Input
                  value={fetchApproveReject?.RequestApproval?.project_code}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Project Name"

                //rules={[{ required: true, message: 'Please select a project' }]}
              >
                <Input
                  value={fetchApproveReject?.RequestApproval?.project_name}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item label="User Name">
                <Input value={fetchApproveReject?.User?.givenName} disabled />
              </Form.Item>
            </Col>
            {/* <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="SBG"
                //name="project_name"
                //rules={[{ required: true, message: 'Please select a project' }]}
              >
                <Input value={fetchApproveReject?.RequestApproval?.sbg} disabled/>
              </Form.Item>
            </Col> */}
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Role of the Employee"
                //name="bu"
                //rules={[{ message: 'Please enter the project name' }]}
              >
                <Input
                  value={fetchApproveReject?.RequestApproval?.role}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Email"
                //name="sbu_id"
                //rules={[{ message: "Please enter the project code" }]}
              >
                <Input value={fetchApproveReject?.User?.email} disabled />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                label="User Remarks"
                name="manager_user_remarks"
                placeholder="Enter remarks"
              >
                <TextArea span={24} rows={3} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      ),
    },
  ];
  return (
    <div className="main-div">
      <div className="steps_parent_bbs approver">
        <Steps
          className="steps_track_bbs manager"
          style={stepStyle}
          current={currentStep}
          labelPlacement="vertical"
        >
          {steps.map((item, index) => (
            <Step
              className="manager-icon"
              key={index}
              icon={
                <img
                  src={index === currentStep ? step_base_icon : inactive_bbs}
                  alt="Step Icon"
                  className="step-icon relative"
                />
              }
              title={
                <div className="step-title-container flex flex-col">
                  <div className="step-title text-blue-800 font-semibold text-sm">
                    {item.title}
                  </div>
                </div>
              }
            />
          ))}
        </Steps>
      </div>

      <div className="step-card flex justify-center items-center">
        <div className="steps_content_parent ">
          <Card>
            <div className="steps-content">
              {steps[currentStep] ? (
                steps[currentStep].content
              ) : (
                <div>No content available</div>
              )}
            </div>
            <div className="steps-action text-center mt-4">
              {currentStep === 0 && (
                <>
                  <Button
                    style={{ margin: '0 8px' }}
                    onClick={() => navigate('/dashboard')}
                    className="prev-button"
                  >
                    Back to Dashboard
                  </Button>

                  <Button
                    style={{ margin: '0 4px' }}
                    type="primary"
                    loading={loading}
                    onClick={() => handleProjectEdit(params.id)}
                    className="next-button"
                    disabled={
                      fetchApproveReject?.RequestApproval?.project_status ==
                      'Approved'
                    }
                  >
                    Submit
                  </Button>

                  <Button
                    style={{ margin: '0 4px' }}
                    type="primary"
                    onClick={nextStep}
                    className="next-button"
                    disabled={
                      !(
                        fetchApproveReject?.RequestApproval?.project_status ===
                          'Approved' ||
                        (fetchApproveReject?.RequestApproval?.project_status ===
                          'Rejected' &&
                          isSubmitClicked)
                      )
                    }
                  >
                    Next
                  </Button>
                </>
              )}

              {/* Step 1 */}
              {currentStep === 1 && (
                <>
                  <Button
                    style={{ margin: '0 8px' }}
                    onClick={() => navigate('/dashboard')}
                    className="prev-button"
                  >
                    Back to Dashboard
                  </Button>

                  <Button
                    type="primary"
                    loading={loading}
                    onClick={() => handleUserEdit(params.id)}
                    className="next-button"
                  >
                    Submit
                  </Button>
                </>
              )}

              {/* Common Rejection Modal */}
              <Modal
                visible={isRejectionModalVisible}
                onOk={handleRejectionConfirm}
                onCancel={handleRejectionCancel}
                footer={[
                  <Button
                    className="rounded-lg text-[14px] font-['SF-Pro-Text-Regular, sans-serif'] text-[#344054] md:w-[170px] w-auto"
                    key="cancel"
                    onClick={handleRejectionCancel}
                  >
                    Cancel
                  </Button>,
                  <Button
                    className="bg-[#F43E3E] rounded-lg text-[14px] font-['SF-Pro-Text-Regular, sans-serif'] text-[#FFFFFF] md:w-[170px] w-auto"
                    key="reject"
                    type="primary"
                    onClick={handleRejectionConfirm}
                  >
                    Reject
                  </Button>,
                ]}
                style={{ zIndex: 1050 }}
                title={
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                      src={dangerIcon} // Update with the correct path
                      alt="Danger Icon"
                      style={{
                        width: '48px',
                        height: '48px',
                        marginRight: '8px',
                      }}
                    />
                  </div>
                }
                width={400}
              >
                <Form
                  form={form} // Connect the form instance
                  layout="vertical" // Use vertical layout for labels and inputs
                >
                  <Form.Item
                    label="Rejection"
                    name="remarks" // Form field name
                  >
                    <Input.TextArea
                      className="w-[352px] border-[#D0D5DD] border-[1px]"
                      rows={3}
                    />
                  </Form.Item>
                </Form>
              </Modal>

              <Modal
                visible={isUserRejectionModalVisible}
                onOk={handleUserRejectionConfirm}
                onCancel={handleUserRejectionCancel}
                footer={[
                  <Button
                    className="rounded-lg text-[14px] font-['SF-Pro-Text-Regular, sans-serif'] text-[#344054] md:w-[170px] w-auto"
                    key="cancel"
                    onClick={handleUserRejectionCancel}
                  >
                    Cancel
                  </Button>,
                  <Button
                    className="bg-[#F43E3E] rounded-lg text-[14px] font-['SF-Pro-Text-Regular, sans-serif'] text-[#FFFFFF] md:w-[170px] w-auto"
                    key="reject"
                    type="primary"
                    onClick={handleUserRejectionConfirm}
                  >
                    Reject
                  </Button>,
                ]}
                style={{ zIndex: 1050 }}
                title={
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                      src={dangerIcon} // Update with the correct path
                      alt="Danger Icon"
                      style={{
                        width: '48px',
                        height: '48px',
                        marginRight: '8px',
                      }}
                    />
                  </div>
                }
                width={400}
              >
                <Form
                  form={form} // Connect the form instance
                  layout="vertical" // Use vertical layout for labels and inputs
                >
                  <Form.Item
                    label="Rejection"
                    name="remarks" // Form field name
                  >
                    <Input.TextArea
                      className="w-[352px] border-[#D0D5DD] border-[1px]"
                      rows={3}
                    />
                  </Form.Item>
                </Form>
              </Modal>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default UserApproveReject;
